import Vue from 'vue'
import commonMutations from '@/store/data/common/mutations'
import { get, isNil, findIndex, find } from 'lodash'

const mutations = {
    setDeletedItem(state, { id, dataType }) {
        state.list = state.list.filter(item => {
            return !(parseInt(item['id']) === parseInt(id) && item['jsonKey']['type'] === dataType) && item['parentJsonKeyName'] !== 'connection_' + id
        })
    },

    setCreatedItem(state, { item, type }) {
        const _item = {
            ...item,
            jsonKey: {
                type,
                subType: item.type,
                ids: [item.id],
                name: `connection-${item.id}`
            }
        }
        state.list.push(_item)
    },

    setUpdatedItem(state, { item, dataType }) {
        const finishedAlertEmail = get(item, 'finish_alert_emails', null)
        if (!isNil(finishedAlertEmail)) {
            item.finish_alert_emails = JSON.parse(item.finish_alert_emails)
                .join(',')
                .replace(',', ', ')
        }

        state.list = state.list.map(it => {
            if (parseInt(it['id']) === parseInt(item.id) && it['jsonKey']['type'] === dataType) {
                for (const key in item) {
                    if (typeof it[key] !== 'undefined') {
                        it[key] = item[key]
                    }
                }
            }
            return it
        })
    },
    setItemToActive(state, { id }) {
        const list = state.list
        const itemIndex = findIndex(state.list, item => item.id === id)
        const item = find(state.list, item => item.id === id)
        item.status = 'active'
        list.splice(itemIndex, 1, item)
        Vue.set(state, 'list', list)
    }
}

export default { ...commonMutations, ...mutations }
